(function stickySidebar() {
  var contentHeight = 0,
    currentWidth,
    newWidth,
    mediaPoint = 1119,
    sectionContentBlog = $('.js-scroll-container'),
    paddingBottom = 0;

  if (sectionContentBlog.hasClass('js-scroll-container_narrow')) {
    mediaPoint = 919;
  }

  function setContainersHeight() {
    var sidebarHeight = 0;
    $('.js-fixed-inner').each(function () {
      const thisHeight = $(this).outerHeight();
      thisHeight > sidebarHeight && (sidebarHeight = thisHeight);
    });
    sectionContentBlog.css('min-height', (sidebarHeight));
    let refreshadHeight = sectionContentBlog.height() + paddingBottom;
    if (refreshadHeight !== contentHeight) {
      contentHeight = refreshadHeight;
      $('.js-fixed-col').css('height', contentHeight);
      $(document.body).trigger("sticky_kit:recalc");
    };
  }

  function launchStickySidebar() {
    $('.js-fixed-col').css('height', contentHeight);
    $('.js-inner-scrolling-stop .js-fixed-inner').stick_in_parent({
      offset_top: 120,
      inner_scrolling: false,
    });
    $('.js-fixed-inner').stick_in_parent({
      offset_top: 120,
      inner_scrolling: true,
    });
  }

  $(window).on('resize', function () {
    setContainersHeight();
    newWidth = window.innerWidth;
    if (newWidth > mediaPoint && currentWidth <= mediaPoint) {
      launchStickySidebar();
    } else if (newWidth <= mediaPoint && currentWidth > mediaPoint) {
      $('.js-fixed-inner').trigger("sticky_kit:detach");
      $('.js-fixed-col').removeAttr('style');
    }
    currentWidth = newWidth;
  });

  $(document).ready(function () {
    setContainersHeight();
    currentWidth = window.innerWidth;
    var lazyLoadElements = $('.js-fixed-col .lazy');

    lazyLoadElements.on('load error', function() {
      $(window).trigger('resize');
    });

    if (currentWidth > mediaPoint) {
      launchStickySidebar();
    }

    $(window).on('scroll', function () {
      setContainersHeight();
    });
  });

  // Fix for BS collapses to refresh sticky sidebar
  $(".js-collapse").on('shown.bs.collapse hidden.bs.collapse', function(e) {
    $(window).trigger('resize');
  })
})();
